import './more-options.css';

import React from 'react';
import { SearchFilterContainer } from '../search-filter-container';

export interface MoreOptionsProps {
  children?: React.ReactNode;
  isOpen: boolean;
  open(): void;
  close(): void;
}

export const MoreOptions: React.FC<MoreOptionsProps> = props => {

  return (
    <div className="more-options-container">
      <div className="wide-screen">
        <button className={props.isOpen ? 'filter-button filter-button-selected' : 'filter-button'} onClick={props.open}>More</button>
      </div>
      <div className="thin-screen">
        <button className={props.isOpen ? 'filter-button filter-button-selected filter-button-when-condensed' : 'filter-button filter-button-when-condensed'} onClick={props.open}>Filters</button>
      </div>
      {props.isOpen &&
        <SearchFilterContainer close={props.close} title="More Options" alignRight>
          {props.children}
        </SearchFilterContainer>
      }
    </div>
  );
}
